module.exports = __webpack_public_path__ + "img/user-data-ccb-bg.ad22955e.png";